import React, { useEffect } from 'react'
import styled from 'styled-components'
import routes from '../routes'
import { SIZES } from '../styles/theme'
import { desktopAssets, mobileAssets } from '../containers/PreCache'
import Media from 'react-media'
import { HiChevronRight } from 'react-icons/hi'
import { useHistory } from 'react-router'

export default function LandingPage() {
  const history = useHistory()

  const showHelpDesk = () => {
    // Guard: window.chaport is undefined while the widget script is disabled
    // (see public/index.html / config.ENABLE_CHAPORT) — calling .q on it
    // unconditionally would throw.
    if (window.chaport) {
      window.chaport.q('hideLauncher')
    }
  }

  useEffect(showHelpDesk, [])

  return (
    <Media query={`(max-width: ${SIZES.mobileBreakpoint})`}>
      {(matches) =>
        matches ? (
          <MobilePage>
            <div className="event-content">
              <img
                className="event-title-lockup"
                src={mobileAssets.countdownMobileTitle}
                alt="National Tax Conference 2026 — 26th Edition. Future-Ready Tax: Driving Trust, Transparency and Transformation"
              />
            </div>
            <div className="access-wrapper">
              <button className="access-btn" onClick={() => history.push(routes.login)}>
                CLICK HERE TO ACCESS NTC 2026
                <HiChevronRight aria-hidden="true" />
              </button>
            </div>
          </MobilePage>
        ) : (
          <Page>
            <img
              className="event-title"
              src={desktopAssets.countdownTitle}
              alt="National Tax Conference 2026 — 26th Edition. Future-Ready Tax: Driving Trust, Transparency and Transformation"
            />
            <button className="access-btn" onClick={() => history.push(routes.login)}>
              CLICK HERE TO ACCESS NTC 2026
              <HiChevronRight aria-hidden="true" />
            </button>
          </Page>
        )
      }
    </Media>
  )
}

const Page = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  height: 100%;
  min-height: 100vh;
  background: url(${desktopAssets.countdownDesktopBg});
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  color: #262c65;
  overflow: hidden;

  .event-title {
    position: absolute;
    top: 6.5741%;
    left: 4.1667%;
    /* Size by height so the title's gold date banner can never overlap the
       button on wide/short viewports. 44.1204% = 953/2160, matching the 16:9
       design — identical to the countdown page for visual consistency. */
    height: 44.1204%;
    width: auto;
    max-width: 46.3542%;
    display: block;
    z-index: 1;
  }

  .access-btn {
    /* Access button — placed where the countdown sits on the countdown page.
       left: 89/1920, top: 649/1080 per the Figma "Access NTC 2026" frame.
       Sized in vw so it scales with the stretched background like the
       countdown digits do. */
    position: absolute;
    top: 60.0926%;
    left: 4.6354%;
    z-index: 2;
    display: inline-flex;
    align-items: center;
    gap: 0.5208vw;
    padding: 0.8333vw 1.0417vw;
    background: var(--Gold-Gradient-01);
    color: #fff;
    border: none;
    border-radius: 0.5208vw;
    box-shadow: 0 4px 6.15px rgba(0, 0, 0, 0.21);
    font-family: 'Din', 'DIN', sans-serif;
    font-weight: 700;
    font-size: 1.5625vw;
    line-height: 1;
    text-transform: uppercase;
    white-space: nowrap;
    cursor: pointer;
    transition: transform 0.15s ease-in-out;

    &:hover {
      transform: translateY(-2px);
    }

    svg {
      width: 1.7708vw;
      height: 1.7708vw;
      flex-shrink: 0;
    }
  }
`

const MobilePage = styled.div`
  width: 100%;
  height: 100dvh;
  min-height: 100dvh;
  position: relative;
  background: url(${mobileAssets.countdownMobileBg});
  background-size: 100% 100%;
  background-position: center top;
  background-repeat: no-repeat;
  overflow: hidden;
  color: #262c65;

  .event-content {
    width: 85.7506%;
    position: absolute;
    top: 6.338dvh;
    left: 5.3435%;
    z-index: 1;
  }

  .event-title-lockup {
    /* 21.2441dvh = 362/1704, matching the mobile design frame. */
    height: 21.2441dvh;
    width: auto;
    max-width: 100%;
    display: block;
  }

  .access-wrapper {
    position: absolute;
    top: 61.0329dvh;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    z-index: 2;
  }

  .access-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    background: var(--Gold-Gradient-01);
    color: #fff;
    border: none;
    border-radius: 10px;
    box-shadow: 0 4px 6.15px rgba(0, 0, 0, 0.21);
    font-family: 'Din', 'DIN', sans-serif;
    font-weight: 700;
    font-size: 1.125rem;
    line-height: 1;
    text-transform: uppercase;
    cursor: pointer;
    transition: transform 0.15s ease-in-out;

    &:hover {
      transform: translateY(-2px);
    }

    svg {
      width: 1.375rem;
      height: 1.375rem;
      flex-shrink: 0;
    }
  }
`
